import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=2fe407cc&scoped=true&"
import script from "./AboutNew.vue?vue&type=script&lang=js&"
export * from "./AboutNew.vue?vue&type=script&lang=js&"
import style0 from "./AboutNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AboutNew.vue?vue&type=style&index=1&id=2fe407cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe407cc",
  null
  
)

export default component.exports